import * as React from 'react';
import parse, { domToReact } from 'html-react-parser';


import { Carousel } from 'react-bootstrap';
import { View, Touchable, Text, rem } from '../libs/WebComponents';
import { Props } from '../types/types';

const AppTipsGeneral = (props: Props) => {

   const [sindex, setSIndex] = React.useState(0);
   const [animate, setAnimate] = React.useState(false);

   const handleSelect = (selectedIndex: number) => {
     setSIndex(selectedIndex);
   };

   let children: any;
   
   parse(props.body,{
      replace(domNode: any) {

         if (domNode.attribs && domNode.attribs.class === 'row') {
            children = domNode.children.map((child: any, key: number)=>{
               if(child.attribs && child.attribs.class.substr(0,4) === 'col-')
               {
                  child.attribs.class = 'carousel-tip';
                  return <Carousel.Item key={key}>{domToReact([child])}</Carousel.Item>;
               }
            }).filter((child: any)=>child);
         }
      }}
   );

   return (
         <View>
            <Carousel className={'carousel-tips'} activeIndex={sindex} onSelect={handleSelect} pause={false} touch={true} nextIcon={null} prevIcon={null} onSlide={()=>setAnimate(false)} onSlid={()=>setAnimate(true)}>
            {children}
            </Carousel>
            <Touchable onPress={(uuid: number)=>props.onClose(uuid)}><Text className={'text-center'} style={{textDecoration:'underline', color:'var(--color-white)',fontSize:rem(1.5)}}>Overslaan</Text></Touchable>
            <View style={{minHeight:rem(2)}}/>
         </View>
   );
}

export default React.memo(AppTipsGeneral);

